export default {
    navigationBarTitleText: intl.get('padPage.mine.mine')
};
